import React, { useEffect, useState } from 'react';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import { useTranslation } from '../../../app/LanguageContext';
import { inferDefaultSelections } from './productOptionSyncUtils';

export default function OptionDefaultsForExistingDialog({
  open,
  newOptions = [],
  prefillDefaults = {},
  existingVariantCount = 0,
  onClose,
  onConfirm,
}) {
  const { translate } = useTranslation();
  const [defaults, setDefaults] = useState({});

  useEffect(() => {
    if (open) {
      setDefaults(inferDefaultSelections(newOptions, prefillDefaults));
    }
  }, [open, newOptions, prefillDefaults]);

  const allFilled = (newOptions || []).every((opt) => {
    const key = opt.key;
    return key && String(defaults[key] ?? '').trim();
  });

  const handleConfirm = () => {
    onConfirm?.({ ...defaults });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{translate('products.option_defaults_dialog_title')}</DialogTitle>
      <DialogContent dividers>
        <Alert severity="info" sx={{ mb: 2 }}>
          {translate('products.option_defaults_dialog_hint').replace(
            '{count}',
            String(existingVariantCount),
          )}
        </Alert>
        {(newOptions || []).map((opt) => (
          <FormControl key={opt.key || opt.name} fullWidth size="small" sx={{ mb: 2 }}>
            <InputLabel id={`option-default-${opt.key}`}>
              {translate('products.option_defaults_field').replace('{option}', opt.name)}
            </InputLabel>
            <Select
              labelId={`option-default-${opt.key}`}
              label={translate('products.option_defaults_field').replace('{option}', opt.name)}
              value={defaults[opt.key] || ''}
              onChange={(e) => setDefaults((prev) => ({ ...prev, [opt.key]: e.target.value }))}
            >
              {(opt.values || []).map((val) => (
                <MenuItem key={val} value={val}>
                  {val}
                </MenuItem>
              ))}
            </Select>
            <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
              {translate('products.option_defaults_apply_all')}
            </Typography>
          </FormControl>
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{translate('common.cancel')}</Button>
        <Button variant="contained" onClick={handleConfirm} disabled={!allFilled}>
          {translate('common.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
